import * as types from "../../../databse/types";

export const actionGetDataProfileUser = (info) => ({
    type: 'SET_PROFILE_USER', info
});

export const actionEditProfileUser = (objData) => ({
    type: 'EDIT_PROFILE_USER', data: objData
});

export const actionLogOutUser = () => ({type: 'LOG_OUT'});

export const actionSetTokenUser = (token) => ({
    type: 'SET_TOKEN_USER', token
});
export const actionGetAddressUser = (address) => ({
    type: 'GET_ADDRESS_USER', address
});
export const actionSelectItemActiveAddress = (activeAddress) => ({
    type: 'SELECT_ITEM_ACTIVE_ADDRESS', activeAddress
});

export const actionRemoveItemAddress = (address) => ({
    type: types.ADDRESS_REMOVE_ITEM_ADDRESS,
    address
});
